import { autoserialize, inheritSerialization } from 'cerialize';
import { PersonSuspension } from './person-suspension';

@inheritSerialization(PersonSuspension)
export class PersonSuspensionDetail extends PersonSuspension {
  @autoserialize
  createdBy: string;

  @autoserialize
  modifiedBy: string;

  @autoserialize
  deactivatedBy: string;
}
